
import { useState } from "react";

/**
 * Returns orchestration-level active state
 */
export function useOrchestrationState() {
  const [orchestrationActive, setOrchestrationActive] = useState(false);
  const [taskComplexity, setTaskComplexity] = useState<'simple' | 'medium' | 'complex'>('medium');
  
  return { 
    orchestrationActive, 
    setOrchestrationActive,
    taskComplexity,
    setTaskComplexity
  };
}
